import React from 'react';

import type { SlackEmbedErrorCode } from '@neptune/shared/core-auth-domain';
import { bemBlock, Icon, Layout, Text } from '@neptune/shared/venus-ui';

import './SlackEmbedStatusPage.less';

const block = bemBlock('slack-embed-status-page');

const SLACK_EMBED_STATUS_COPY: Record<SlackEmbedErrorCode, { title: string; body: string }> = {
  session_expired: {
    title: 'Session expired',
    body: 'Refresh the panel in Slack to open the chart again.',
  },
  no_access: {
    title: 'No access',
    body: 'Your Neptune account cannot open this chart. Ask a project owner for access.',
  },
  not_found: {
    title: 'Chart not found',
    body: 'This report version or widget no longer exists.',
  },
  unsupported_widget: {
    title: 'Preview not available',
    body: 'This widget type cannot be shown here.',
  },
  no_data: {
    title: 'No data',
    body: 'The chart has no data to show.',
  },
  error: {
    title: 'Something went wrong',
    body: 'Refresh the panel in Slack.',
  },
};

type SlackEmbedStatusPageProps = {
  code: SlackEmbedErrorCode;
};

export function SlackEmbedStatusPage({ code }: SlackEmbedStatusPageProps) {
  const { title, body } = SLACK_EMBED_STATUS_COPY[code];

  return (
    <Layout.Column
      className={block()}
      role="alert"
      data-role="slack-embed-status"
      data-status={code}
      alignItems="center"
      justifyContent="center"
      spacedChildren="sm"
    >
      <Icon glyph="exclamation-circle" size="2x" color="text-subdued" />
      <Text component="h1" size="xl" fontWeight="semibold" color="text">
        {title}
      </Text>
      <Text className={block('body')} size="base" color="text-subdued">
        {body}
      </Text>
    </Layout.Column>
  );
}
